import { connect } from 'react-redux';
import { IStoreState } from 'src/entity/StateEntity';
import WalletBindCardPage from 'src/components/views/Wallet/WalletBindCardPage';

const mapStateToProps = ({ userState: { isAgent, isDomestic, userInfo } }: IStoreState) => ({
  isAgent,
  isDomestic,
  userInfo,
});

export default connect(mapStateToProps)(WalletBindCardPage);


// WEBPACK FOOTER //
// ./src/containers/WalletBindCard.ts